import React, {useState} from 'react';
import './CreateCampaignsContent.css'
import CreateCustomCampaign from "../CreateCampaignsTypes/CreateCustomCampaign/CreateCustomCampaign";
import CreateTimeCampaign from "../CreateCampaignsTypes/CreateTimeCampaign/CreateTimeCampaign";
import CreateVolumeCampaign from "../CreateCampaignsTypes/CreateVolumeCampaign/CreateVolumeCampaign";
import {campaignsTypes} from "../CreateCampaignsSideMenu/CreateCampaignsSideMenu";
import Modal from "../../../Modal/Modal";


export const CAMPAIGNS_TYPE = {
    volumeCampaign: "volumeCampaign",
    timeCampaign: "timeCampaign",
    locationCampaign: "locationCampaign",
};

const CreateCampaignsContent = (props) => {
    const [componentForRenderingInModal, setComponentForRenderingInModal] = useState(<></>);
    const [showModal, setShowModal] = useState(false);
    let createCampaignsLayout = [];

    const {sendCampaigns ,campaignType, companyData, visits, newCampaignsListUid, companyLogoURL, loading} = props;

    const handleCampaignData = (newCampaignsData) => {
        sendCampaigns(newCampaignsData)
    };

    const openModal = (component) => {
        setShowModal(true);
        setComponentForRenderingInModal(component);

    };
    const closeModal = () => {
        setShowModal(false);
    };

    switch (campaignType) {
        case campaignsTypes.custom: {
            createCampaignsLayout = <CreateCustomCampaign
                handleCampaignData={handleCampaignData}
                handleModalData={openModal}
                closeModal={closeModal}
                companyData={companyData}
                visits={visits}
                newCampaignsListUid={newCampaignsListUid}
                companyLogoURL={companyLogoURL}
                loading={loading}/>;
            break;
        }
        case campaignsTypes.time: {
            createCampaignsLayout = <CreateTimeCampaign
                handleCampaignData={handleCampaignData}
                companyData={companyData}
                visits={visits}/>;
            break;
        }
        case campaignsTypes.volume: {
            createCampaignsLayout = <CreateVolumeCampaign
                handleCampaignData={handleCampaignData}
                handleModalData={openModal}
                closeModal={closeModal}
                companyData={companyData}
                visits={visits}
                companyLogoURL={companyLogoURL}
                loading={loading}/>;
            break;
        }
        default:
            createCampaignsLayout = [];
    }

    return (
        <div className='crate-campaigns-content'>
            <div className='campaign-type-wrapper'>
                <h5 className='campaign-type-title'>{campaignType} Campaigns</h5>
            </div>
            <div className='crate-campaigns'>
                {createCampaignsLayout}
            </div>
            <Modal showing={showModal} closeModal={closeModal}>
                {componentForRenderingInModal}
            </Modal>
        </div>
    )
};

export default CreateCampaignsContent;

